import _ from "lodash"
import config from "./config"

/**
 * Frontend application configuration holder.
 * This is a customer dependant configuration with:
 *  - hard coded configuration in plugin
 *  - database driven configuration (see DT#106238)
 *
 *  If any conflicts happened between options and plugin configuration, then database would get priority
 */
class AppConfig {
  constructor(options) {
    _.assign(this, config)
    _.assign(this, options)
  }
}

export default new AppConfig()
